var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.appClassNames,attrs:{"id":"app"}},[(_vm.$store.state.app.navbar)?[_c('Navbar')]:_vm._e(),_c('main',[_c('router-view')],1),_c('AppFooter'),_c('ExclusiveControlModal'),_c('ErrorModal')],2)}
var staticRenderFns = []

export { render, staticRenderFns }